<template>
  <div class="input-container" :style="{ margin: margin, height: height }">
    <label :class="{ labelObrigatorio: campoVazio && required }"> {{ label }}</label>
    <div v-if="temIcon" class="field">
      <p class="control has-icons-right">
        <input
          class="input"
          :id="id"
          :type="type"
          :required="required"
          :placeholder="placeholder"
          :value="modelValue"
          @input="$emit('update:modelValue', $event.target.value)"
          :maxlength="maxLength"
          :mensagemCampoObrigatorio="mensagemCampoObrigatorio"
          v-e2e="nativeInputId"
        />
        <span class="icon is-small is-right">
          <i class="mdi" :class="classIcon"></i>
        </span>
      </p>
    </div>

    <input
      v-else
      class="input"
      :type="type"
      :placeholder="placeholder"
      :id="id"
      :maxlength="maxLength"
      :required="required"
      :class="{ inValida: (campoVazio && required) || !isDataValida }"
      :value="modelValue"
      :disabled="isDisabled"
      @input="$emit('update:modelValue', $event.target.value)"
      @keyup="($event)=>this.verificarSeInputEstaVazio($event)"
      @blur="this.verificarSeDataEValida()"
      :mensagemCampoObrigatorio="mensagemCampoObrigatorio"
      v-e2e="nativeInputId"
    />

    <span v-if="tipLabel" class="tip-label is-size-7">{{ tipLabel }}</span>

    <div class="mensagemDeErro" v-if="required">
      <span v-if="campoVazio && mensagemCampoObrigatorio" class="campo-obrigatório">
        {{ mensagemCampoObrigatorio }}
      </span>

      <span v-else-if="campoVazio && label != null" class="campo-obrigatório">
        {{ label }} é obrigatório.
      </span>

      <span v-else-if="campoVazio && isDataValida" class="campo-obrigatório">
        Campo obrigatório.
      </span>
      
      <span v-if="!isDataValida && type == 'date'" class="campo-obrigatório">
        Formato de data inválido
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "TrfInput",
  props: {
    label: String,
    placeholder: String,
    margin: String,
    height: String,
    temIcon: Boolean,
    classIcon: String,
    modelValue: String,
    required: {
      type: Boolean,
      default: true
    },
    id: String,
    maxLength: String,
    type: String,
    tipLabel: String,
    isDisabled: {
      type: Boolean,
      default: false
    },
    mensagemCampoObrigatorio: String
    
  },
  data() {
    return {
      campoVazio: false,
      isDataValida: true,
    };
  },
  computed: {
    nativeInputId() {
      if (!this.id) return ''

      return `${this.id}-native-input`
    }
  },
  methods: {
    verificarSeInputEstaVazio(event) {

      if (event?.key == 'Tab') {
        return;
      }
      
      if (this.type != "date") {
        this.campoVazio = !this.modelValue || this.modelValue.trim() == "";
        return this.campoVazio;
      }
    },

    verificarSeInputDoTipoDateEstaVazio() {
      const input = document.querySelector('input[type="date"]');
      if (!input.validity.badInput && input.validationMessage && input.value == "") {
        this.campoVazio = true
        return this.campoVazio;
      } else if (input.validity.badInput || input.value != "") {
        this.campoVazio = false
        return this.campoVazio;
      }
    },

    verificarSeDataEValida() {
     if(this.type == "date"){
      const inputDate =  document.querySelector('input[type="date"]');
      this.verificarSeInputDoTipoDateEstaVazio();
      this.isDataValida =
        inputDate.validationMessage && inputDate.validity.badInput || inputDate.value == ""
          ? false
          : true;
      if (!this.isDataValida) {
        inputDate.value = "";
      }
      return this.isDataValida;
     }
    },

    limparValidacao() {
      this.campoVazio = false;
    },
    
    limparInput() {
      this.modelValue == ''
    }
  },
};
</script>

<style lang="scss" scoped>
.input-container {
  margin-bottom: 15px;
}

label {
  display: block;
  margin-bottom: 5px;
}
.inValida {
  border: 1px solid #a94442;
}
.mensagemDeErro {
  margin: 0 0 1% 0;
  color: #a94442;
  font-size: 12px;
}
.labelObrigatorio {
  color: #a94442;
}
.tip-label {
  color: #4a4a4a;
  vertical-align: top;
}
</style>
